import { render, staticRenderFns } from "./ResumeItemContentItem.vue?vue&type=template&id=223c1790&scoped=true&"
import script from "./ResumeItemContentItem.vue?vue&type=script&lang=js&"
export * from "./ResumeItemContentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c1790",
  null
  
)

export default component.exports